import { useMemo } from "react";
import { TextFormatter } from "../muiTableHelper";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

export const ActivitiesListColumns = ({ setEditData, setShowModal }) => {
  return useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.name,
          });
        },
      },
      {
        accessorKey: "code",
        header: "Code",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.code,
          });
        },
      },
      {
        accessorKey: "codeNumber",
        header: "Code number",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.codeNumber,
          });
        },
      },
      {
        accessorKey: "actions",
        header: "Actions",
        Cell: ({ row }) => {
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setEditData(row.original);
                  setShowModal(true);
                }}>
                <EditIcon />
              </IconButton>
            </>
          );
        },
      },
    ],
    [setEditData, setShowModal]
  );
};

export default ActivitiesListColumns;
